module.exports = __webpack_public_path__ + "img/antena-1.b5708f23.png";